/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { useT } from 'i18n/hooks/useT';

type UploadCopyTextProps = {
  isBold?: boolean;
};

const UploadCopyText = styled.p<UploadCopyTextProps>`
  color: #fff;
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
  font-size: 1.4rem;
  line-height: 1.6rem;
  white-space: normal;
  text-align: left;
`;

export function SupportedFormatsTooltip() {
  const t = useT();
  return (
    <div
      css={css`
        z-index: 1;
      `}
    >
      <UploadCopyText
        css={css`
          margin-bottom: 14px;
        `}
      >
        {t(
          'EpisodeEditorScreen.SupportedFormatsTooltip.SupportedAudioFormatsMessage',
          'Supported audio formats: all audio formats (up to 250MB per file)',
          'Upload supported formats tooltip message'
        )}
      </UploadCopyText>
      <UploadCopyText
        css={css`
          margin-bottom: 14px;
        `}
      >
        {t(
          'EpisodeEditorScreen.SupportedFormatsTooltip.SupportedVideoFormatsMessage',
          'Supported video formats: mov and mp4 (less than 3 hours in play length)',
          'Upload supported formats tooltip message'
        )}
      </UploadCopyText>
      <UploadCopyText>
        {t(
          'EpisodeEditorScreen.SupportedFormatsTooltip.FilesRightsMessage',
          'Only upload files that you have the rights to import to Anchor and distribute to other platforms.',
          'Upload supported formats tooltip message'
        )}
      </UploadCopyText>
    </div>
  );
}
